/**
 * Baris chip faset (Kategori / Merek / Segmen) di halaman Hasil Pencarian &
 * browse Kategori/Merek. Tap = toggle filter (MULTI-pilih, mig 169); chip aktif
 * diwarnai. Daftar kosong → tidak dirender. Bersama untuk semua dimensi agar
 * tampilan filter seragam (beda dari `BrandRow` beranda yang ber-avatar inisial).
 */
export function FacetChipRow({
  title,
  items,
  active,
  onToggle,
}: {
  title: string;
  items: string[];
  /** Nilai-nilai terpilih (multi). */
  active: string[];
  onToggle: (name: string) => void;
}) {
  if (!items.length) return null;

  const activeLower = new Set(active.map((a) => a.toLowerCase()));

  return (
    <section className="border-t border-neutral-100 bg-white px-3 py-2">
      <h2 className="mb-1.5 text-[10px] font-bold uppercase tracking-wide text-muted">
        {title}
      </h2>
      <div className="no-scrollbar flex gap-1.5 overflow-x-auto">
        {items.map((name) => {
          const isActive = activeLower.has(name.toLowerCase());
          return (
            <button
              key={name}
              type="button"
              onClick={() => onToggle(name)}
              className={`h-8 shrink-0 rounded-full border px-3 text-xs font-bold transition ${
                isActive
                  ? "border-shopee bg-shopeeSoft text-shopee"
                  : "border-neutral-200 bg-white text-ink"
              }`}
            >
              {name}
            </button>
          );
        })}
      </div>
    </section>
  );
}
